import * as React from "react";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { Link } from "react-router-dom";

export default class RedireccionConsulta extends React.Component<RedireccionConsultaProps> {

    render() {
        const { textoAyuda, url, textoLink } = this.props;

        const tooltip = (
            <Tooltip id="tooltip" className="tooltip-pos" arrowOffsetTop={20}>{textoAyuda}</Tooltip>
        );

        return (
            <OverlayTrigger placement="top" overlay={tooltip}>
                <Link to={url}>
                    {textoLink}
                </Link>
            </OverlayTrigger>
        );
    }
}

interface RedireccionConsultaProps {
    url: string,
    textoAyuda: string,
    textoLink: string
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_general/componentes/RedireccionConsulta.tsx